import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabService {
  static readonly NO_HEADER_TAB = '10';

  private selectedTab = new BehaviorSubject<string>(TabService.NO_HEADER_TAB);
  selectedTab$ = this.selectedTab.asObservable();

  constructor() { }

  clearHeaderNavSelection(): void {
    this.setSelectedTab(TabService.NO_HEADER_TAB);
  }

  setSelectedTab(tab: string) {
    this.selectedTab.next(tab);
    localStorage.setItem('selectedTab', tab);
  }
}
